import { Global, useTheme } from "@emotion/react";

function ensureArray(
  value,
  isEmpty = (value) => value == null || value === "",
) {
  if (Array.isArray(value)) {
    return value;
  }
  if (isEmpty(value)) {
    return [];
  }
  return [value];
}

export default function GlobalStyles({ ...restProps }) {
  const theme = useTheme();
  let {
    fonts = {},
    fontFamily = [Object.keys(fonts)[0], "system-ui", "sans-serif"]
      .filter(Boolean)
      .join(", "),
  } = theme?.typography || {};
  let fontFaceDeclarations = [];
  Object.entries(fonts).forEach(([fontFamily, value]) => {
    if (typeof value === "string") {
      value = { src: value };
    }
    let {
      src,
      fontWeight = "100 900",
      fontDisplay = "swap",
      fontStyle = ["normal", "italic"],
      ...rest
    } = value;
    if (!src) {
      throw new Error(`No src provided for font "${fontFamily}" in theme`);
    }
    fontStyle = ensureArray(fontStyle);
    if (typeof src !== "object") {
      src = fontStyle.reduce(
        (acc, fontStyle) => ({ ...acc, [fontStyle]: src }),
        {},
      );
    }
    Object.entries(src).forEach(([fontStyle, src]) => {
      if (!/^url\(/.test(src)) {
        src = `url("${src}") format("${src.split(".").at(-1)}")`;
      }
      let fontFaceDeclaration = {
        fontFamily: `"${fontFamily}"`,
        fontStyle,
        fontWeight,
        fontDisplay,
        src,
        ...rest,
      };
      fontFaceDeclarations.push(fontFaceDeclaration);
    });
  });
  const styles = [
    ...fontFaceDeclarations.map((fontFaceDeclaration) => ({
      "@font-face": fontFaceDeclaration,
    })),
    {
      body: {
        fontFamily,
        margin: 0,
        ...theme.styleUtils.colorTheme("white"),
        accentColor: theme.getColor("primary"),
      },
      ".wsui-screen-only": {
        "@media not screen": {
          display: "none !important",
        },
      },
    },
  ];
  return <Global styles={styles} {...restProps} />;
}
